import { useEffect, useState } from 'react';

import { observer } from 'mobx-react-lite';
import { Reordonner } from 'react-sdk/activities/Reordonner';
import { Activity } from 'react-sdk/Vertx/MeetingsApi/Activity';
import classes from './ReordonnerPopup.module.css';

import {
  defaultDropAnimationSideEffects,
  DndContext,
  DragOverlay,
  MouseSensor,
  pointerWithin,
  useSensor,
  useSensors
} from '@dnd-kit/core';
import {
  arrayMove,
  // rectSortingStrategy,
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';

import { snapCenterToCursor } from '@dnd-kit/modifiers';
import ScaleManager from 'react-sdk/ScaleManager';
// import AppState from '../../../js/AppState';
// import ActivityPeda from '../ActivityPeda/ActivityPeda';
import ReordonnerDraggable from './ReordonnerDraggable';
import ReordonnerProposition from './ReordonnerProposition';
import AppState from '@/js/AppState';

// import { Sortable } from './Sortable';


function scaleModifier(args) {

  const { transform } = args;

  return {
    ...transform,
    x: (transform.x / ScaleManager.scale) + (ScaleManager.marginPos === "left" ? ScaleManager.margin : 0),
    y: (transform.y / ScaleManager.scale) - (ScaleManager.marginPos === "top" ? ScaleManager.margin : 0)
  }
}

const dropAnimationConfig = {
  sideEffects: defaultDropAnimationSideEffects({
    styles: {
      active: {
        opacity: '0.5',
      },
    },
  }),
};



/**
 * La popup qui affiche le Réordonner (en différentes étapes)
 * @param {Object} props
 * @param {Activity} props.activity
  */
const ReordonnerGame = ({ instance, onReadyToValidate }) => {

  const [refreshToken, setRefreshToken] = useState(null);
  const [activeId, setActiveId] = useState(null);
  const [showSorted, setShowSorted] = useState(false);


  const [hoveredId, setHoveredId] = useState(null);

  useEffect(() => {
    instance.shufflePropositions()
    setRefreshToken(rt => rt + 1)
  }, []);

  useEffect(() => {
    if (instance.result && !showSorted) {
      let result = instance.result
      // instance.result = null
      let to = setTimeout(() => {
        instance.result = result
        setShowSorted(true)
      }, 3000)

      return () => clearTimeout(to)
    }
  }, [instance.result, showSorted]);


  const mouseSensor = useSensor(MouseSensor);
  // const touchSensor = useSensor(TouchSensor);
  // const keyboardSensor = useSensor(KeyboardSensor);
  const sensors = useSensors(
    mouseSensor,
    // touchSensor,
    // keyboardSensor
  );

  function handleDragStart(event) {
    if (AppState.waiting) return

    let { active } = event

    setActiveId(active.id)
  }

  function handleDragOver(event) {
    const { over } = event;
    if (!over) {
      setHoveredId(null)
      return
    }

    setHoveredId(over.id)
  }

  function handleDragEnd(event) {

    const { active, over } = event;
    setActiveId(null)
    setHoveredId(null)

    if (!over) return

    if (active.id !== over.id) {

      const oldIndex = instance.Propositions.findIndex(p => p.ID === active.id)
      const newIndex = instance.Propositions.findIndex(p => p.ID === over.id)
      // setItems((items) => {
      //   const oldIndex = items.indexOf(active.id);
      //   const newIndex = items.indexOf(over.id);

      //   return arrayMove(items, oldIndex, newIndex);
      // });
      instance.Propositions = arrayMove(instance.Propositions, oldIndex, newIndex);

      setTimeout(() => {
        onReadyToValidate(true)
      }, 100)
    }
  }

  if (!instance) return null

  return (

    <DndContext
      sensors={sensors}
      collisionDetection={pointerWithin}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      onDragOver={handleDragOver}
    >
      <div className={classes.List_ctnr}>

        {(instance.label_top && instance.label_bottom) &&
          <div className={classes.List_labels}>
            <div className={classes.label_top}>{instance.label_top.Text}</div>
            <div className={classes.label_arrow} />
            <div className={classes.label_bottom}>{instance.label_bottom.Text}</div>
          </div>}

        {!instance.result &&
          <div className={classes.List}>
            <SortableContext items={instance.Propositions} strategy={verticalListSortingStrategy}>
              {instance.Propositions.map(proposition => (
                <ReordonnerDraggable
                  key={proposition.ID}
                  proposition={proposition}
                  hovered={hoveredId === proposition.ID} />
              ))}
            </SortableContext>
          </div>
        }
        {instance.result && <>
          <div className={classes.List}>
            {instance.Propositions
              .toSorted((a, b) => {
                if (!showSorted) return 0

                if (a.initialIndex < b.initialIndex) return -1
                if (a.initialIndex > b.initialIndex) return 1
                return 0

              })
              .map((proposition, index) => (
                <ReordonnerProposition key={"proposition_" + proposition.ID} proposition={proposition} corrected={showSorted ? 2 : 1} index={index} />)
              )}
          </div>
        </>}
      </div>
      <DragOverlay dropAnimation={dropAnimationConfig}
        modifiers={[
          snapCenterToCursor,
          scaleModifier,
          // restrictToWindowEdges,
          // restrictToVerticalAxis,
        ]}
      >

        {activeId ?
          <ReordonnerProposition proposition={instance.getProposition(activeId)} dragged /> : null}

      </DragOverlay>

      {instance.result && !showSorted && <div className={classes.wait_correction}>La correction va s'afficher dans un instant</div>}

    </DndContext>
  );
}

export default observer(ReordonnerGame)
